import { Controller } from "@hotwired/stimulus"
import { gsap } from "gsap"
import { SplitText } from "gsap/SplitText"
import { ScrollTrigger } from "gsap/ScrollTrigger"

export default class extends Controller {
	static values = {
		direction: {
			type: String,
			default: "horizontal"
		}
	}

	connect() {
		gsap.registerPlugin(SplitText)
		gsap.registerPlugin(ScrollTrigger)

		for (const title of this.titles) {
			const split = SplitText.create(title, { type: "words" })
			gsap.from(split.words, {
				duration: 1,
				x: this.directionValue == "horizontal" ? -15 : null,
				y: this.directionValue == "vertical" ? 25 : null,
				autoAlpha: 0,
				stagger: 0.15,
				ease: "power4.out",
				delay: 0.25,
				scrollTrigger: {
					trigger: this.element,
					start: "top 75%"
				}
			})
		}

		for (const subtitle of this.subtitles) {
			const split = SplitText.create(subtitle, { type: "words" })
			gsap.from(split.words, {
				duration: 1,
				x: this.directionValue == "horizontal" ? -15 : null,
				y: this.directionValue == "vertical" ? 25 : null,
				autoAlpha: 0,
				stagger: 0.15,
				ease: "power4.out",
				delay: 0.75,
				scrollTrigger: {
					trigger: this.element,
					start: "top 75%"
				}
			})
		}
	}

	get titles() {
		return this.element.querySelectorAll("h1, h2, h3")
	}

	get subtitles() {
		return this.element.querySelectorAll("p, h4, h5, h6")
	}
}
